import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "../../UI/Table";
import { useSortableTable } from "../../../hooks/useSortableTable";
import { formatDate } from "../../../utils/formatDate";

const RegistrationsTab = ({ data }) => {
  const { registrations } = data;

  const {
    sortedData: sortedRequests,
    handleSort,
    getSortIndicator,
  } = useSortableTable(registrations);

  const tableHeaders = [
    { key: "email", label: "Email", sortable: true },
    { key: "name", label: "Name", sortable: true },
    { key: "registrant_ip_address", label: "IP", sortable: true },
    { key: "amount", label: "Amount", sortable: true },
    { key: "transaction_id", label: "Transaction Id", sortable: true },
    { key: "created", label: "Created Date", sortable: true },
  ];

  if (sortedRequests.length === 0) {
    return (
      <div className="tab-content">
        <h3>Registrations</h3>
        <div className="tab-empty">No registrations found.</div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <h3>Registrations</h3>
      <Table>
        <TableHeader>
          {tableHeaders.map((header, index) => (
            <TableCell
              key={index}
              header
              onClick={
                header.sortable ? () => handleSort(header.key) : undefined
              }
              style={{
                cursor: header.sortable ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {header.label}
                {header.sortable && getSortIndicator(header.key)}
              </div>
            </TableCell>
          ))}
        </TableHeader>
        <TableBody>
          {sortedRequests.map((registration) => (
            <TableRow key={registration.id}>
              <TableCell>{registration.email}</TableCell>
              <TableCell>{registration.name}</TableCell>
              <TableCell>{registration.registrant_ip_address}</TableCell>
              <TableCell className="row__amount">
                $
                {registration.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
              <TableCell>{registration.transaction_id}</TableCell>
              <TableCell>
                {formatDate(registration.created)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RegistrationsTab;
